import PropTypes from 'prop-types'
import React, { useState, useEffect} from 'react'
import { useDrop } from '../contexts/DropContext'
import {FaUpload} from "react-icons/fa"
import 'react-tooltip/dist/react-tooltip.css'
import {Tooltip as ReactTooltip} from "react-tooltip"



const CellTip = ({sessionID, info }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const project = useDrop().currentDrop;

  useEffect(() => {
    setIsLoaded(true);
  }, [info]);

  if (!isLoaded) {
    return null;
  }

  var rand_id = Math.floor(Math.random() * 10000);
  rand_id = rand_id.toString();

  return (
    
    <div style={{ justifyContent: "center" }} data-tooltip-content={info} id={sessionID + info + rand_id}>
      {info}
      <ReactTooltip anchorId={sessionID + info + rand_id} />
    </div>
);
};


CellTip.propTypes = { 
  sessionID: PropTypes.string,
  onClick: PropTypes.func,
}

export default CellTip